import React, { useState, useEffect, useMemo } from "react";
import { RootState } from "../../models/RootState";
import { NavLink, useParams } from "react-router-dom";
import "./ExchangeMarketsPage.scss";
import SAP_API from "../../services/sap";
import { connect, useSelector } from "react-redux";
import { BookMakers, EventData, LimitDto, MatchOdds, TopicUrls } from "../../models/EventData";
import MatchOddsTable from "../MatchOddsTable/MatchOddsTable";
import BMTable from "../BMTable/BMTable";
import FancyTable from "../FancyTable/fancyTable";
import { IonCol, IonRow } from "@ionic/react";
import { Accordion, AccordionDetails, Button, Checkbox, Tab, Tabs } from "@mui/material";
import TabPanel from "../TabPanel/TabPanel";
import PremiumMarkets from "../PremiumMarkets/PremiumMarkets";
import { fetchEventInfo, getAllMatchOddsData, getBookMakerMarkets } from "../../store/exchangeSports/exchangeSportsAction";
import moment from "moment";
import { ExpandLessSharp, ExpandMoreSharp } from "@mui/icons-material";
import LiveStream from "../LiveStream/LiveStream";
import { checkStompClientSubscriptions, disconnectToWS, subscribeForMatchOdds, subscribeSportRadarEventOdds, subscribeWsForBookmakerMarkets, subscribeWsForFancyMarkets } from "../../websockets/webSocket";
import ExchOpenBets from "../ExchOpenBets/ExchOpenBets";
import { UserBet } from "../../models/ExchBetSlip";
import { fetchOpenBets } from "../../store/exchBetSlip/exchBetSlipAction";
import { setEventInfoOnSuccess } from "../../store/exchangeSports/exchangeSportsReducer";
import { removeExchangeBet, setIsOneClickBettingEnabled } from "../../store/exchBetSlip/exchBetSlipReducer";
import { useNavigate } from "react-router";
import { setTextColor, getTextColorFromCSSVar } from "../../store/authActions";
import { UserDetails } from "../../models/UserDetails";
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import OneClickBetting from "../OneClickBetting";
import { OneClickBettingLoader } from "../OneClickBetting/OneClickLoader";
import { Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";
import { useTranslation } from "../../hooks/useTranslation";

declare global {
  interface Window {
    ScorecardV2?: {
      loadScorecard?: (options: {
        containerId: string;
        eventId: string;
        baseUrl: string;
        theme?: string;
        lang?: string;
      }) => void;
    };
  }
}

const SCORECARD_SDK_SCRIPT_ID = "scorecard-v2-sdk-script";
const SCORECARD_SDK_SRC = "https://sdk.indisports.live/v2/scorecard-sdk-v2.umd.js";
const SCORECARD_CONTAINER_ID = "scorecard-container";

type StoreProps = {
  eventInfo: EventData;
  openBets: UserBet[];
  fetchEventInfo: (sportId: any, eventId: any, navigate: Function) => void;
  fetchOpenBets: (eventId: string, sportId: string) => void;
  setEventInfoOnSuccess: () => void;
  removeExchangeBet: (index: number) => void;
  topicUrls?: TopicUrls;
  eventMarkets: MatchOdds[];
  bmMarkets: BookMakers[];
  betFairWSConnected: boolean;
  sportsRadarWSConnected: boolean;
  dreamWSConnected: boolean;
  wallets: any;
  Browser: any;
  isOneClickBettingEnabled: boolean;
  setIsOneClickBettingEnabled: (isOneClickBettingEnabled: boolean) => void;
  bettingInprogress: boolean;
  userDetails?: UserDetails;
  dynamicTextColors?: any;
};

export const ExchangeMarketsPage: React.FC<StoreProps> = (props) => {
  const { t } = useTranslation();
  const {
    eventInfo,
    fetchEventInfo,
    openBets,
    fetchOpenBets,
    removeExchangeBet,
    topicUrls,
    eventMarkets,
    bmMarkets,
    betFairWSConnected,
    sportsRadarWSConnected,
    dreamWSConnected,
    setEventInfoOnSuccess,
    wallets,
    Browser,
    isOneClickBettingEnabled,
    setIsOneClickBettingEnabled,
    bettingInprogress,
    dynamicTextColors,
  } = props;

  const { gameInfo } = useParams();
  const [sportId, competitionId, eventId] = atob(gameInfo || "").split("|");
  let [marketData, setMarketData] = useState<EventData | null>();
  const { exchData } = useSelector((state: RootState) => state.userDetails);
  const userDetails = useSelector((state: RootState) => state.userDetails?.userDetails);

  // Get dynamic text color classes from Redux instead of calling function
  const pageTextColorClass = dynamicTextColors?.pageTextColorClass || '';
  const tableTextColorClass = dynamicTextColors?.tableTextColorClass || '';
  const tabTextColorClass = dynamicTextColors?.accordionSummaryTextColorClass || '';
  const teamInfoTextColorClass = dynamicTextColors?.teamInfoTextColorClass || '';
  const buttonTextColorClass = dynamicTextColors?.ionButtonTextColorClass || '';
  
  // Get text color for inactive tabs (transparent background, shows page background)
  const inactiveTabTextColorClass = pageTextColorClass;
  
  // Create class names for active and inactive tabs
  const activeTabClass = `active-tab-${buttonTextColorClass}`;
  const inactiveTabClass = `inactive-tab-${inactiveTabTextColorClass}`;

  const [tabVal, setTabVal] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [scorecardID, setScorecardID] = useState<string>('');
  const [fancyTabVal, setFancyTabVal] = useState(0);
  const navigate = useNavigate();
  const [scExpanded, setScExpanded] = useState(true);
  const [lsExpanded, setLsExpanded] = useState(true);
  const [obExpanded, setObExpanded] = useState(true);
  const [prLimits, setPRLimits] = useState<LimitDto>();
  const [bal, setBal] = useState<Number>(0);
  const [exp, setExp] = useState<Number>(0);
  const [isScorecardSdkLoaded, setIsScorecardSdkLoaded] = useState(false);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchEventInfo(sportId, eventId, navigate);
      fetchOpenBets(eventId, sportId);
      setLoading(false);
    };

    fetchData();
  }, []);

  const matchOddsMarkets = useMemo(
    () => eventMarkets?.filter((market) => market.marketName.toLowerCase() === "match odds"),
    [eventMarkets]
  );

  const nonMatchOddsMarkets = useMemo(
    () => eventMarkets?.filter((market) => market.marketName.toLowerCase() !== "match odds"),
    [eventMarkets]
  );

  useEffect(() => {
    const matchingWallet = wallets.find(
      (wallet: any) => wallet?.walletName === "POINTS"
    );
    if (matchingWallet) {
      setBal(matchingWallet?.balance);
      setExp(matchingWallet?.exposure);
    }
  }, [wallets]);

  useEffect(() => {
    return () => {
      setEventInfoOnSuccess()
      removeExchangeBet(0);
      disconnectToWS()
      setMarketData(null);
    };
  }, []);

  useEffect(() => {
    if (eventInfo?.eventId && eventInfo?.eventId !== "" && (betFairWSConnected || sportsRadarWSConnected || dreamWSConnected)) {
      if (eventInfo.markets.matchOdds.length > 0 && topicUrls?.matchOddsTopic) {
        for (let mo of eventInfo.markets.matchOdds) {
          subscribeForMatchOdds(
            topicUrls?.matchOddsTopic,
            "",
            eventInfo.eventId,
            mo.marketId
          );
        }
      }
      if (
        eventInfo.markets?.bookmakers &&
        eventInfo.markets?.bookmakers?.length > 0 &&
        topicUrls?.bookMakerTopic
      ) {
        for (let bm of eventInfo.markets.bookmakers) {
          subscribeWsForBookmakerMarkets(topicUrls?.bookMakerTopic, eventInfo.eventId, bm.marketId);
        }
      }

      if (
        eventInfo?.markets?.fancyMarkets &&
        eventInfo?.markets?.fancyMarkets?.length > 0 &&
        topicUrls?.fancyTopic
      ) {
        subscribeWsForFancyMarkets(topicUrls?.fancyTopic, eventInfo.eventId);
      }

      if (eventInfo && eventInfo?.markets?.premiumMarkets && eventInfo?.markets?.premiumMarkets?.length > 0 && topicUrls?.premiumTopic) {
        subscribeSportRadarEventOdds(
          topicUrls?.premiumTopic,
          "",
          eventInfo?.markets?.premiumEventId
        );
      }
    }
  }, [betFairWSConnected, eventInfo?.eventId, sportsRadarWSConnected, dreamWSConnected]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
  
      if (event.data?.type === "SCORECARD_HEIGHT") {
        const iframe = document.getElementById("scorecard-frame");
        if (iframe) iframe.style.height = `${event.data.height}px`;
      }
    };
  
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  

  useEffect(() => {
    if (topicUrls?.matchOddsBaseUrl) {
      const baseUrlsPayload = {
        matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
        bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
        premiumBaseUrl: topicUrls?.premiumBaseUrl,
      };
      checkStompClientSubscriptions(baseUrlsPayload);
    }
  }, [topicUrls]);

  useEffect(() => {
    if (eventInfo?.markets?.premiumMarkets?.length > 0 && prLimits?.minBetValue === undefined) {
      const limitsDto = eventInfo?.markets?.premiumMarkets?.[0]?.limits
      if (limitsDto?.minBetValue) {
        setPRLimits({
          minBetValue: limitsDto?.minBetValue,
          maxBetValue: limitsDto?.maxBetValue,
          oddsLimit: limitsDto?.oddsLimit,
        });
      }
    }
  }, [eventInfo?.markets?.premiumMarkets]);

  useEffect(() => {
    setMarketData(eventInfo);
  }, [eventInfo]);

  useEffect(() => {
    if (
      fancyTabVal === 0 && marketData?.markets?.fancyMarkets?.length === 0
    ) {
      setFancyTabVal(1); // Switch to "PREMIUM" tab if "FANCY" is empty
    }
  }, [marketData]);

  const getSREventIdByBetFairId = async () => {
    try {
      await SAP_API.post(`/feed/get-sr-event`, {
        eventId: eventInfo?.eventId.split('_').join(':'),
      }).then((result: any) => {
        if (result?.data?.status === 'RS_OK')
          setScorecardID(
            result?.data?.srEventDetails?.srEventId?.split(':')[2]
          );
        else setScorecardID("");
      });
    } catch (err) {
      setScorecardID("");
    }
  };

  useEffect(() => {
    const tg = window?.Telegram?.WebApp;

    tg?.BackButton?.show();

    tg?.expand();

    const telegramVersion = parseFloat(tg?.version || "0");
    if (telegramVersion >= 8.0) {
      // tg?.requestFullscreen();
      tg?.lockOrientation();
    }

    const backClickHandler = () => {
      handleBackClick();
    };

    tg?.BackButton?.onClick(backClickHandler);

    return () => {
      tg?.BackButton?.hide();
      tg?.BackButton?.offClick(backClickHandler);
      const telegramVersion = parseFloat(tg?.version || "0");
      if (telegramVersion >= 8.0) {
        // tg?.exitFullscreen();
        if (tg?.isOrientationLocked) {
          tg?.unlockOrientation();
        }
      }
    };
  }, []);

  useEffect(() => {
    if (eventInfo?.eventId) {
      // if (eventInfo?.providerName?.toLocaleLowerCase() === "sportradar") {
      //   setScorecardID(eventInfo?.eventId?.split("sr:match:")?.[1]);
      // } else {
      //   getSREventIdByBetFairId()
      // }
      setScorecardID(eventInfo?.eventId);
    }
  }, [eventInfo?.eventId]);

  const isCredScorecard = eventInfo?.sc && eventInfo.sc.toLowerCase() === "crex";

  useEffect(() => {
    if (!isCredScorecard) {
      return;
    }

    // eslint-disable-next-line no-console
    console.log("ScorecardV2: detected cred scorecard, sc =", eventInfo?.sc);

    if (window.ScorecardV2 && typeof window.ScorecardV2.loadScorecard === "function") {
      // eslint-disable-next-line no-console
      console.log("ScorecardV2: SDK already present on window.");
      setIsScorecardSdkLoaded(true);
      return;
    }

    const handleLoad = () => {
      if (window.ScorecardV2 && typeof window.ScorecardV2.loadScorecard === "function") {
        // eslint-disable-next-line no-console
        console.log("ScorecardV2: SDK script loaded and loadScorecard is available.");
        setIsScorecardSdkLoaded(true);
      } else {
        // eslint-disable-next-line no-console
        console.error("ScorecardV2 failed to load or is not in the correct format.");
      }
    };

    const existingScript = document.getElementById(SCORECARD_SDK_SCRIPT_ID) as HTMLScriptElement | null;
    if (existingScript) {
      // eslint-disable-next-line no-console
      console.log("ScorecardV2: reusing existing SDK script tag.");
      existingScript.addEventListener("load", handleLoad);
      return () => existingScript.removeEventListener("load", handleLoad);
    }

    // eslint-disable-next-line no-console
    console.log("ScorecardV2: creating SDK script tag with src:", SCORECARD_SDK_SRC);
    const script = document.createElement("script");
    script.id = SCORECARD_SDK_SCRIPT_ID;
    script.src = SCORECARD_SDK_SRC;
    script.async = true;
    script.onload = handleLoad;
    script.onerror = () => {
      // eslint-disable-next-line no-console
      console.error("Failed to load ScorecardV2 SDK script.");
    };

    document.body.appendChild(script);

    return () => {
      script.onload = null;
    };
  }, [isCredScorecard, eventInfo?.sc]);

  useEffect(() => {
    if (!isCredScorecard) {
      return;
    }
    if (!scExpanded) {
      return;
    }

    if(tabVal !== 0) {
      return;
    }

    if (!isScorecardSdkLoaded) {
      return;
    }
    if (!eventInfo?.eventId) {
      return;
    }

    const container = document.getElementById(SCORECARD_CONTAINER_ID);
    if (!container) {
      // eslint-disable-next-line no-console
      console.error("ScorecardV2: container not found in DOM:", SCORECARD_CONTAINER_ID);
      return;
    }

    try {
      // eslint-disable-next-line no-console
      console.log("ScorecardV2: initializing scorecard with eventId", eventInfo.eventId);
      window.ScorecardV2?.loadScorecard?.({
        containerId: SCORECARD_CONTAINER_ID,
        eventId: eventInfo.eventId,
        baseUrl: "https://cc-distributor.indisports.live/",
        theme: "dark",
        lang: "en",
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error while initializing ScorecardV2:", error);
    }
  }, [isCredScorecard, isScorecardSdkLoaded, eventInfo?.eventId, scExpanded, tabVal]);

  useEffect(() => {
    if (tabVal === 2) {
      fetchOpenBets(eventInfo?.eventId, eventInfo?.sportId)
    }
  }, [tabVal]);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <>
      {/* One-click betting loader overlay */}
      {isOneClickBettingEnabled && bettingInprogress && (
        <div className="fixed inset-0 bg-black/70 z-[9999] flex items-center justify-center">
          <OneClickBettingLoader />
        </div>
      )}

      {
        loading ? (
          <div className="home-loading">
            <img src={`/${Loader(domain)}`} style={{ height: '10rem' }} />
          </div>
        ) : (
          <>
            <IonRow className={`eam-ctn ${pageTextColorClass}`}>
              <IonCol className="mob-stream-section">
                <IonRow className="eam-info-header eam-info-header-name">
                  <div className="eam-teams-name">
                    <div className="flex items-center">
                      {
                        Browser === "Web" && (
                          <div className={`flex items-center h-[40px] px-[7px] rounded-[40px] back-btn ${teamInfoTextColorClass}`}>
                            <FontAwesomeIcon
                              icon={faChevronLeft}
                              onClick={handleBackClick}
                              className={`cursor-pointer object-contain shrink-0 ${teamInfoTextColorClass}`}
                            />
                          </div>
                        )
                      }
                      <div className={`${teamInfoTextColorClass} eam-teams-name-ctn`}>
                        <div className="eam-team-1">{eventInfo?.eventName}</div>
                        <div className="eam-date-time">
                          <span>
                            {moment(
                              eventInfo?.openDate
                            ).format('hh')}
                          </span>
                          :
                          <span>
                            {moment(
                              eventInfo?.openDate
                            ).format('mm A')}
                          </span>&nbsp;
                          {moment(
                            eventInfo?.openDate
                          ).format('DD MMM YYYY')}
                        </div>
                      </div>
                    </div>

                    <div className="eam-bal-ctn">
                      <div className={`${teamInfoTextColorClass} eam-bal`}>
                        <div>
                          {`${t("common.balance")}: `}
                          <span className="bal-value">{bal.toFixed(2)}</span>
                        </div>
                        <div>
                          {`${t("common.exposure")}: ${exp.toFixed(2)}`}
                        </div>
                      </div>
                    </div>
                  </div>
                </IonRow>

                {
                  // isMobile &&
                  (
                    // openBets.length > 0 ||
                    // (eventInfo && eventInfo.status === 'IN_PLAY')) ? (
                    <>
                      <Tabs
                        value={tabVal}
                        className={`eam-all-markets-header-tabs ${tabTextColorClass}`}
                        onChange={(_, newValue) => {
                          setTabVal(newValue);
                        }}
                      >
                        <Tab
                          label={
                            <div className={`flex items-center gap-2 ${tabTextColorClass}`}>
                              <span>{t("sports.scorecard")}</span>
                              {
                                <span onClick={(e) => {
                                  e.stopPropagation();
                                  setScExpanded(!scExpanded);
                                }}
                                  className="cursor-pointer">
                                  {scExpanded ? (
                                    <ExpandLessSharp />
                                  ) : (
                                    <ExpandMoreSharp />
                                  )}
                                </span>
                              }
                            </div>
                          }
                          value={0}
                          disabled={['99990', '2378961'].includes(eventInfo?.sportId)}
                          className={tabVal === 0 ? activeTabClass : inactiveTabClass}
                        />
                        {!['101480', 'sr:tournament:2472'].includes(eventInfo?.competitionId) && (
                          <Tab
                            label={
                              <div className={`flex items-center gap-2 ${tabTextColorClass}`}>
                                <span>{t("sports.liveStream")}</span>
                                {
                                  <span onClick={(e) => {
                                    e.stopPropagation();
                                    setLsExpanded(!lsExpanded);
                                  }}
                                    className="cursor-pointer">
                                    {lsExpanded ? (
                                      <ExpandLessSharp />
                                    ) : (
                                      <ExpandMoreSharp />
                                    )}
                                  </span>
                                }
                              </div>
                            }
                            value={1}
                            disabled={
                              !(eventInfo && eventInfo.status === 'IN_PLAY') ||
                              ['99990', '2378961'].includes(eventInfo?.sportId)
                            }
                            className={tabVal === 1 ? activeTabClass : inactiveTabClass}
                          />
                        )}
                        <Tab
                          label={
                            <div className={`flex items-center gap-2 ${tabTextColorClass}`}>
                              <span>{t("sports.openBets")} ({openBets?.length || 0}) </span>
                              {
                                <span onClick={(e) => {
                                  e.stopPropagation();
                                  setObExpanded(!obExpanded);
                                }}
                                  className="cursor-pointer">
                                  {obExpanded ? (
                                    <ExpandLessSharp />
                                  ) : (
                                    <ExpandMoreSharp />
                                  )}
                                </span>
                              }
                            </div>
                          }
                          value={2}
                          className={tabVal === 2 ? activeTabClass : inactiveTabClass}
                        />
                      </Tabs>
                      <TabPanel
                        value={tabVal}
                        index={0}
                        className="event-stat-mobile-ctn"
                      >
                        <div>
                          {tabVal === 0 &&
                            eventInfo &&
                            eventInfo.sportId !== '99990' &&
                            scorecardID &&
                            (eventInfo.status === 'IN_PLAY' ||
                              eventInfo.status === 'SUSPENDED') ? (
                            <>
                              {scExpanded && (
                                <Accordion
                                  className="scorecard-accordion"
                                  expanded={true}
                                >
                                  {/* <AccordionSummary
                          expandIcon={
                            <ExpandLessSharp className="expand-icon" />
                          }
                          aria-controls="panel1a-content"
                          className="scorecard-header"
                        >
                          {"Live Score"}
                        </AccordionSummary> */}
                                  <AccordionDetails className="scorecard-detail">
                                    <div className="widgets">
                                      <div>
                                        <div className="sr-widget sr-widget-1">
                                          {isCredScorecard ? (
                                            <div
                                              id={SCORECARD_CONTAINER_ID}
                                              style={{ width: "100%", minHeight: "170px" }}
                                            />
                                          ) : (
                                            eventInfo && (
                                              <iframe
                                                id="scorecard-frame"
                                                src={`https://win.mysportsfeed.io/?sportId=${eventInfo.sportId}&eventId=${eventInfo.eventId}`}
                                                width="100%"
                                                height="0"
                                                title="Scorecard"
                                              />
                                            )
                                          )}
                                        </div>
                                        {/* <>
                                          {eventInfo?.sportId === "sr:sport:21" || eventInfo?.sportId === "4" ? (
                                            <Script
                                              strategy="afterInteractive"
                                              dangerouslySetInnerHTML={{
                                                __html: `
          (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
          g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
          )})(window,document,"script", "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", {
          theme: false, // using custom theme
          language: "en"
          });
          SIR("addWidget", ".sr-widget-1", "match.lmtlight", {layout: "double", scoreboard: "extended", momentum: "extended", collapseTo: "momentum",  activeSwitcher: "scoreDetails", matchId:"${scorecardID}"});
        `,
                                              }}
                                            />
                                          ) : (
                                            <Script
                                              strategy="afterInteractive"
                                              dangerouslySetInnerHTML={{
                                                __html: `
          (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
          g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
          )})(window,document,"script", "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", {
          theme: false, // using custom theme
          language: "en"
          });
          SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {layout: "double", scoreboard: "extended", momentum: "extended", collapseTo: "momentum",  activeSwitcher: "scoreDetails", matchId:"${scorecardID}"});
        `,
                                              }}
                                            />
                                          )}
                                        </> */}
                                      </div>
                                    </div>
                                  </AccordionDetails>
                                </Accordion>
                              )}
                            </>
                          ) : null}
                        </div>
                      </TabPanel>
                      <TabPanel
                        value={tabVal}
                        index={1}
                        className="eam-header-tab-panel"
                      >
                        {!['101480', 'sr:tournament:2472'].includes(eventInfo?.competitionId) && tabVal === 1 ? (
                          <>
                            {lsExpanded && (
                              <div className="live-stream-ctn">
                                <LiveStream
                                  eventID={
                                    eventInfo?.sportId === '99994'
                                      ? eventInfo?.markets?.bookmakers?.length > 0
                                        ? eventInfo.eventId
                                        : 'sr:match:' + scorecardID
                                      : eventInfo?.markets?.matchOdds?.length === 0 &&
                                        eventInfo?.markets?.bookmakers?.length > 0 &&
                                        eventInfo?.markets?.premiumMarkets?.length > 0
                                        ? 'sr:match:' + scorecardID
                                        : eventInfo.eventId
                                  }
                                />
                              </div>
                            )}
                          </>
                        ) : null}
                      </TabPanel>
                      <TabPanel
                        value={tabVal}
                        index={2}
                        className="event-stat-mobile-ctn"
                      >
                        {obExpanded && (
                          <>
                            {openBets.length > 0 ? (
                              <ExchOpenBets />
                            ) : (
                              <>
                                <div className={`no-bet-data mob-open-bets-ctn ${pageTextColorClass}`}>
                                  {t("sports.messages.noOpenBetsToShow")}
                                </div>
                              </>
                            )}
                            <div className="btn-background">
                              <div className={`${buttonTextColorClass} btn-mybets`}>
                                <NavLink to={`/betlist`}>
                                  <Button>{t("sports.viewAll")}</Button>
                                </NavLink>
                              </div>
                            </div>
                          </>
                        )}
                      </TabPanel>
                    </>
                  )}
              </IonCol>
              <IonCol className="eam-events-table-section">
                {
                  marketData?.providerName?.toLocaleLowerCase() === "sportradar" ?
                    <div className="">
                      <IonRow className="eam-table-section fancy-tab-section">
                        <PremiumMarkets limits={prLimits} />
                      </IonRow>
                    </div>
                    : (
                      <div className="">
                        <IonRow className="eam-table-section">
                          {marketData &&
                            marketData.markets &&
                            marketData.markets.matchOdds &&
                            matchOddsMarkets ? (
                            <MatchOddsTable eventMarkets={matchOddsMarkets} />
                          ) : null}
                        </IonRow>

                        <IonRow className="eam-table-section">
                          {marketData &&
                            marketData.markets &&
                            marketData.markets.bookmakers &&
                            marketData.markets.bookmakers.length ? (
                            <BMTable bmMarkets={bmMarkets} />
                          ) : null}
                        </IonRow>

                        <IonRow className="eam-table-section">
                          {marketData &&
                            marketData.markets &&
                            marketData.markets.matchOdds &&
                            nonMatchOddsMarkets ? (
                            <MatchOddsTable eventMarkets={nonMatchOddsMarkets} />
                          ) : null}
                        </IonRow>

                        <IonRow className="eam-table-section fancy-tab-section">
                          {marketData &&
                            marketData.markets &&
                            marketData.markets.fancyMarkets &&
                            (marketData.markets.fancyMarkets.length > 0 ||
                              marketData.markets.premiumMarkets.length > 0) ? (
                            // <FancyTable fmData={marketData.markets.fancyMarkets} />
                            <>
                              <Tabs
                                value={fancyTabVal}
                                className={`fancy-market-tabs ${tabTextColorClass}`}
                                onChange={(_, newValue) => {
                                  setFancyTabVal(newValue);
                                }}
                              >
                                {marketData?.markets?.fancyMarkets?.length > 0 ? (
                                  <Tab
                                    label={t("sports.fancy")}
                                    className={`fancy-tab ${tabTextColorClass}`}
                                    value={0}
                                  />
                                ) : null}
                                {marketData?.markets?.premiumMarkets?.length > 0 ? (
                                  <Tab
                                    label={t("sports.premium")}
                                    className={`fancy-tab premium-markets ${tabTextColorClass}`}
                                    value={1}
                                  />
                                ) : null}
                              </Tabs>
                              <div className="fancy-tab-border"></div>
                              <IonRow>
                                <TabPanel
                                  value={fancyTabVal}
                                  index={0}
                                  className="fancy-tab-ctn"
                                >
                                  {marketData?.markets?.fancyMarkets?.length > 0 ? (
                                    <>
                                      <FancyTable />
                                    </>
                                  ) : (
                                    <div className={`no-fancy-msg ${pageTextColorClass}`}>
                                      {t("sports.messages.noFancyMarkets")}
                                    </div>
                                  )}
                                </TabPanel>

                                <IonRow className="row-100">
                                  {' '}
                                  <TabPanel
                                    value={fancyTabVal}
                                    index={1}
                                    className="fancy-tab-ctn"
                                  >
                                    {marketData?.markets?.premiumMarkets?.length > 0 ? (
                                      <>
                                        <PremiumMarkets limits={prLimits} />
                                      </>
                                    ) : (
                                      <div className={`no-fancy-msg ${pageTextColorClass}`}>
                                        {t("sports.messages.noPremiumMarketsMessage")}
                                      </div>
                                    )}
                                  </TabPanel>
                                </IonRow>
                              </IonRow>
                            </>
                          ) : null}

                          {/* <MarketPremium /> */}
                        </IonRow>
                      </div>
                    )
                }
                {isOneClickBettingEnabled ? (
                  <div className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[1000] w-[95%] max-w-[450px]">
                    <OneClickBetting lobby={"EXCHANGE"} />
                  </div>
                ) : (
                  <div
                    className="bg-[var(--table-bg)] rounded-lg p-2 m-1 flex items-center justify-between"
                  >
                    <div
                      className={`flex items-center text-xs font-medium ${tableTextColorClass}`}
                    >
                      <Checkbox
                        color="primary"
                        onClick={() =>
                          setIsOneClickBettingEnabled(!isOneClickBettingEnabled)
                        }
                        checked={isOneClickBettingEnabled}
                        className="text-[var(--ion-color-primary)] pr-1"
                        size="small"
                        style={{
                          padding: '0px',
                          transform: 'scale(0.7)',
                          color: 'var(--ion-color-primary)'
                        }}
                      />
                      {t("sports.oneClickBettingEnabled")}
                    </div>
                  </div>
                )}
                {marketData?.markets?.matchOdds?.length == 0 &&
                  marketData?.markets?.bookmakers?.length == 0 &&
                  marketData?.markets?.fancyMarkets?.length == 0 &&
                  marketData?.markets?.premiumMarkets?.length == 0 && (
                    <div className={`no-fancy-msg ${pageTextColorClass}`}>{t("sports.messages.noMarketsAvailableMessage")}</div>
                  )}
              </IonCol>
            </IonRow>
          </>
        )
      }
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    topicUrls: state?.exchangeSports?.topicUrls,
    eventInfo: state?.exchangeSports.eventInfo,
    betFairWSConnected: state?.exchangeSports?.betFairWSConnected,
    sportsRadarWSConnected: state?.exchangeSports?.sportsRadarWSConnected,
    openBets: state?.exchBetSlip?.openBets,
    dreamWSConnected: state?.exchangeSports?.dreamWSConnected,
    eventMarkets: getAllMatchOddsData(state.exchangeSports.eventInfo),
    bmMarkets: getBookMakerMarkets(state.exchangeSports.eventInfo),
    wallets: state.userDetails?.wallets,
    Browser: state.userDetails.Browser,
    isOneClickBettingEnabled: state?.exchBetSlip?.isOneClickBettingEnabled,
    oneClickBettingStake: state?.exchBetSlip?.oneClickBettingStake,
    bettingInprogress: state?.exchBetSlip?.bettingInprogress,
    dynamicTextColors: state.userDetails?.dynamicTextColors,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    removeExchangeBet: (index: number) => dispatch(removeExchangeBet(index)),
    setEventInfoOnSuccess: () => dispatch(setEventInfoOnSuccess({})),
    fetchOpenBets: (eventId: string, sportId: string) => dispatch(fetchOpenBets(eventId, sportId)),
    fetchEventInfo: (sportId: string, eventId: string, navigate: Function) => dispatch(fetchEventInfo(sportId, eventId, navigate)),
    setIsOneClickBettingEnabled: (isOneClickBettingEnabled: boolean) => dispatch(setIsOneClickBettingEnabled(isOneClickBettingEnabled)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchangeMarketsPage);
